import React from 'react';

export function Mascot({ pose, size = 160, className = '', testId, named = false }) {
  const img = (
    <img
      src={`/mascot/fox-${pose}.webp?v=2`}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      draggable={false}
      data-testid={testId || `mascot-${pose}`}
      className={`select-none object-contain mx-auto ${named ? '' : className}`}
      style={{ width: size, height: size }}
    />
  );
  if (!named) return img;
  return (
    <div className={`flex flex-col items-center ${className}`}>
      {img}
      <span
        data-testid="mascot-name"
        className="-mt-1 px-2.5 py-0.5 rounded-full bg-orange-500 text-white text-[11px] font-bold tracking-wide shadow-sm"
      >
        Vulpi
      </span>
    </div>
  );
}
